<template>
  <div >

      <h1>Error! - 403</h1>
    <h2>This page will display when the user is not properly authenticated.
      Please logout and use a different account, or contact an admin with the proper credentials.</h2>
    </div>

</template>

<script>

import axios from 'axios';


export default {
  name: 'ErrorPage',
  components: {
  },
  data() {
    return {

    };
  },

  mounted() {

  },
  methods: {
  },
};
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    margin-top: 60px;
  }

  .vue-json-form {
    display: block;
    margin: 0 auto;
    width: 60%;
  }
</style>
